/* Local product-page presentation. Native price, variant and cart forms stay in place. */
(() => {
  const translatedCopy = JSON.parse(document.querySelector('#ev-visual-assets')?.textContent || '{}').copy || {};
  const t = (key, fallback) => (translatedCopy[key] || fallback).replaceAll('&amp;', '&');
  if (!document.documentElement.hasAttribute('data-evolve-product')) return;
  const presentation = window.EvolveProductPresentation;
  if (!presentation) { document.documentElement.classList.add('ev-pdp-gallery-fallback'); return; }
  const isModel = text => /\bmodel\s+(shot|wearing)\b|\bon[- ]model\b|\bworn by\b/i.test(text || '');
  const isPromotion = text => /trust.?badge|trust.*authenticity|authenticity.*badge|giftbox[_-]|premium gift box/i.test(text || '');
  const imageUrl = (source, width) => {
    const url = new URL(source, location.href);
    if (url.hostname !== location.hostname) url.protocol = 'https:';
    url.searchParams.set('width', String(width));
    return url.href;
  };
  const imageKey = source => presentation.key(source);
  const hasMultipleSizes = scope => [...(scope?.querySelectorAll('[data-option-name]') || [])].some(option => /^(?:ring[ -])?size$/i.test(option.dataset.optionName) && option.querySelectorAll('input[type="radio"],option').length > 1);
  const cleanProductTitle = info => {
    const title = info?.querySelector('h1');
    if (!title) return;
    const multipleSizes = hasMultipleSizes(info);
    const clean = presentation.cleanTitle(title.textContent, multipleSizes);
    if (clean !== title.textContent.trim()) title.textContent = clean;
  };
  const makeDetails = (title, nodes, className = '') => {
    const content = nodes.filter(Boolean);
    if (!content.length) return null;
    const details = document.createElement('details');
    details.className = `ev-pdp-details ${className}`;
    const summary = document.createElement('summary');
    summary.textContent = title;
    details.append(summary);
    content[0].before(details);
    const body = document.createElement('div');
    body.className = 'ev-pdp-details-body';
    content.forEach(node => body.append(node));
    details.append(body);
    return details;
  };

  const prepareGallery = media => {
    const native = media.querySelector('.splide-image');
    const source = media.querySelector('[id^="stacked-"]') || native;
    if (!native || !source || media.querySelector('.ev-pdp-gallery')) return;
    // Keep the theme's native controls for products containing video or 3D media.
    if (native.querySelector('video, model-viewer, iframe, [data-media-type="video"], [data-media-type="external_video"], [data-media-type="model"]')) return;
    const page = media.closest('.main-product.product-page');
    const info = page?.querySelector('[id^="ProductInfo-"]');
    const sectionId = info?.id.replace('ProductInfo-', '');
    const readVariant = scope => {
      try { return JSON.parse(scope?.querySelector('.variant-selects-main [data-selected-variant]')?.textContent || 'null'); }
      catch { return null; }
    };
    const variantPhoto = variant => ({id:variant?.featured_media?.id,src:variant?.featured_media?.preview_image?.src || variant?.featured_image?.src || variant?.featured_image});
    const promotions = [];
    const collect = () => {
      const activeOnly = !!source.querySelector('.product-media-item.media_active');
      const result = [];
      source.querySelectorAll('img').forEach(image => {
        const src = image.getAttribute('src');
        if (!src) return;
        const item = image.closest('.product-media-item') || image.closest('[data-media-id]');
        if (activeOnly && item?.hasAttribute('data-media-option') && !item.classList.contains('media_active')) return;
        if (isPromotion(`${image.alt} ${src}`)) { if (!promotions.includes(image)) promotions.push(image); return; }
        const multipleSizes = hasMultipleSizes(info);
        result.push({src,alt:presentation.cleanMediaAlt(image.alt, multipleSizes),id:item?.dataset.mediaId?.split('-').pop(),width:image.getAttribute('width'),height:image.getAttribute('height')});
      });
      return result;
    };
    const optionNames = () => [...(info?.querySelectorAll('[data-option-name]') || [])].map(option => option.dataset.optionName);
    let photos = presentation.orderPhotos(collect(), variantPhoto(readVariant(page)), optionNames());
    if (!photos.length) return;
    let featuredKey = imageKey(photos[0].src);
    let active = 0;
    let request = 0;
    let variantPending = false;
    let suppressClick = false;
    let buttons = [];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const gallery = document.createElement('section');
    gallery.className = 'ev-pdp-gallery';
    gallery.hidden = true;
    gallery.setAttribute('aria-label', t('photos','Product photos'));
    const stage = document.createElement('button');
    stage.type = 'button';
    stage.className = 'ev-pdp-stage';
    const meta = document.createElement('div');
    meta.className = 'ev-pdp-gallery-meta';
    const counter = document.createElement('span');
    counter.setAttribute('aria-live', 'polite');
    const enlarge = document.createElement('button');
    enlarge.type = 'button';
    enlarge.textContent = t('full_size','View full size');
    meta.append(counter, enlarge);
    const thumbnails = document.createElement('div');
    thumbnails.className = 'ev-pdp-thumbnails';
    thumbnails.setAttribute('role', 'group');
    thumbnails.setAttribute('aria-label', t('choose_photo','Choose a product photo'));
    const renderThumbnails = () => {
      thumbnails.replaceChildren();
      buttons = photos.map((photo, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ev-pdp-thumb';
        button.dataset.photoKind = index === 0 ? 'product' : presentation.kind(photo);
        button.dataset.mediaId = photo.id || '';
        button.setAttribute('aria-label', `Show photo ${index + 1}: ${isModel(photo.alt) ? t('worn','jewelry being worn') : photo.alt || t('product_view','product view')}`);
        const image = document.createElement('img');
        image.src = imageUrl(photo.src, 180);
        image.alt = '';
        image.width = 80;
        image.height = 80;
        image.loading = 'lazy';
        button.append(image);
        button.addEventListener('click', () => { if (!variantPending) select(index); });
        button.addEventListener('keydown', event => {
          if (variantPending) return;
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % photos.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + photos.length) % photos.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = photos.length - 1;
          if (next == null) return;
          event.preventDefault(); buttons[next].focus({preventScroll:true}); select(next);
        });
        thumbnails.append(button);
        return button;
      });
    };
    const update = index => {
      active = index;
      buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      counter.textContent = `${index + 1} / ${photos.length}`;
      stage.dataset.photoKind = index === 0 ? 'product' : presentation.kind(photos[index]);
      stage.setAttribute('aria-label', `Enlarge photo ${index + 1}: ${photos[index].alt || t('product_view','product view')}`);
      const button = buttons[index];
      const left = button.offsetLeft - thumbnails.offsetLeft;
      if (left < thumbnails.scrollLeft || left + button.offsetWidth > thumbnails.scrollLeft + thumbnails.clientWidth) {
        thumbnails.scrollTo({left:Math.max(0, left - thumbnails.clientWidth / 2 + button.offsetWidth / 2),behavior:reduced.matches ? 'instant' : 'smooth'});
      }
    };
    const createImage = photo => {
      const image = document.createElement('img');
      image.className = 'ev-pdp-photo';
      image.src = imageUrl(photo.src, 1600);
      image.alt = photo.alt;
      image.width = Number(photo.width) || 1600;
      image.height = Number(photo.height) || 1600;
      image.decoding = 'async';
      return image;
    };
    async function show(nextPhotos, index, rebuild = false) {
      const token = ++request;
      const image = createImage(nextPhotos[index]);
      gallery.setAttribute('aria-busy', 'true');
      try { await image.decode(); }
      catch {
        if (token === request) {
          variantPending = false;
          gallery.removeAttribute('aria-busy');
          // A failed variant image must not leave a different metal visible.
          if (rebuild || !stage.querySelector('img')) { gallery.hidden = true; media.classList.remove('ev-pdp-gallery-ready'); media.classList.add('ev-pdp-gallery-fallback'); }
        }
        return;
      }
      if (token !== request || !gallery.isConnected) return;
      photos = nextPhotos;
      featuredKey = imageKey(photos[0].src);
      if (rebuild) renderThumbnails();
      stage.append(image);
      update(index);
      variantPending = false;
      gallery.removeAttribute('aria-busy');
      gallery.hidden = false;
      media.classList.remove('ev-pdp-gallery-fallback');
      media.classList.add('ev-pdp-gallery-ready');
      requestAnimationFrame(() => requestAnimationFrame(() => image.classList.add('is-current')));
      setTimeout(() => {
        if (image !== stage.lastElementChild) return;
        stage.querySelectorAll('img').forEach(previous => { if (previous !== image) previous.remove(); });
      }, reduced.matches ? 0 : 380);
    }
    function select(index) {
      if (variantPending) return;
      // Selecting the visible thumbnail also cancels an older pending decode.
      if (index === active && imageKey(stage.lastElementChild?.src) === imageKey(photos[index].src)) { request++; gallery.removeAttribute('aria-busy'); return; }
      show(photos, index);
    }
    renderThumbnails();
    gallery.append(stage, meta, thumbnails);
    native.before(gallery);
    const initial = media.querySelector('.ev-pdp-initial-photo');
    if (initial && imageKey(initial.src) === imageKey(photos[0].src)) {
      initial.className = 'ev-pdp-photo is-current';
      stage.append(initial);
      gallery.hidden = false;
      media.classList.add('ev-pdp-gallery-ready');
      update(0);
    }
    show(photos, 0);

    const syncVariant = event => {
      if (!media.isConnected) { document.removeEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, syncVariant); initialize(); return; }
      const variant = readVariant(event.detail?.html || page);
      requestAnimationFrame(() => {
        cleanProductTitle(info);
        const next = presentation.orderPhotos(collect(), variantPhoto(variant), optionNames());
        if (!next.length) return;
        const nextFeatured = imageKey(next[0].src);
        const currentKey = imageKey(photos[active].src);
        const sameVariantImage = featuredKey === nextFeatured;
        const sameOrder = next.map(p => imageKey(p.src)).join('|') === photos.map(p => imageKey(p.src)).join('|');
        if (sameVariantImage && sameOrder) {
          // Returning to the displayed variant cancels an older image decode.
          if (variantPending) { request++; variantPending = false; gallery.removeAttribute('aria-busy'); }
          if (gallery.hidden) show(photos, active, true);
          return;
        }
        const retained = sameVariantImage ? next.findIndex(p => imageKey(p.src) === currentKey) : -1;
        variantPending = true;
        if (dialog.open) dialog.close();
        show(next, Math.max(0, retained), true);
      });
    };
    if (sectionId) document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, syncVariant);

    const dialog = document.createElement('dialog');
    dialog.className = 'ev-pdp-lightbox';
    dialog.setAttribute('aria-label', t('enlarged','Enlarged product photo'));
    const close = document.createElement('button');
    close.type = 'button'; close.className = 'ev-pdp-lightbox-close'; close.textContent = t('close','Close');
    const enlarged = document.createElement('img');
    dialog.append(close, enlarged); document.body.append(dialog);
    const openImage = () => {
      if (variantPending) return;
      if (suppressClick) { suppressClick = false; return; }
      enlarged.src = imageUrl(photos[active].src, 2400); enlarged.alt = photos[active].alt; dialog.showModal();
    };
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    stage.addEventListener('click', openImage); enlarge.addEventListener('click', openImage);
    let pointer;
    stage.addEventListener('pointerdown', event => { if (event.pointerType !== 'mouse') pointer = {x:event.clientX,y:event.clientY}; });
    stage.addEventListener('pointerup', event => {
      if (!pointer || variantPending) return;
      const dx = event.clientX - pointer.x, dy = event.clientY - pointer.y;
      pointer = null;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      suppressClick = true; select((active + (dx < 0 ? 1 : -1) + photos.length) % photos.length);
    });
    stage.addEventListener('pointercancel', () => { pointer = null; });
    const auth = info?.querySelector('.x-block-collapsible-tab-evolve_authenticity .rte');
    if (auth) {
      const seen = new Set([...auth.querySelectorAll('img')].map(i => imageKey(i.src)));
      promotions.forEach(promotion => {
        const src = promotion.getAttribute('src');
        if (seen.has(imageKey(src))) return;
        seen.add(imageKey(src));
        const image = document.createElement('img'); image.className = 'ev-pdp-auth-image';
        image.src = imageUrl(src, 600); image.alt = promotion.alt; image.loading = 'lazy'; auth.append(image);
      });
    }
  };


  const prepareInfo = info => {
    if (info.classList.contains('ev-pdp-info-ready')) return;
    info.classList.add('ev-pdp-info-ready');
    const labelQuantity = () => info.querySelectorAll('.x-quantity-selector button[name]').forEach(button => {
      const label = button.name === 'plus' ? 'Increase quantity' : 'Decrease quantity';
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    });
    labelQuantity();
    // Shopify replaces quantity controls after a variant/cart section refresh.
    new MutationObserver(labelQuantity).observe(info, {childList:true, subtree:true});
    const title = info.querySelector('h1');
    if (title) {
      const original = title.textContent.trim();
      const match = original.match(/^(\d+K\s*\/\s*\d+K\s+(?:Yellow|White|Rose) Gold|\d+K Two-tone Yellow & Rose Gold|\d+K\s+(?:Yellow|White|Rose) Gold|Rhodium-Plated Sterling Silver|Sterling Silver|Platinum)\s+(.+)$/i);
      if (match) {
        const metal = document.createElement('p');
        metal.className = 'ev-pdp-metal';
        metal.textContent = match[1];
        title.before(metal);
        title.dataset.originalTitle = original;
        title.textContent = match[2].replace(/^Gold\s+/i, '');
      }
    }
    const buy = info.querySelector('.x-block-buy-buttons');
    cleanProductTitle(info);
    const delivery = info.querySelector('.x-block-estimate-delivery');
    if (buy && delivery) buy.after(delivery);
    if (buy) {
      const wrapPayment = () => {
        const payment = buy.querySelector('.shopify-payment-button');
        if (payment && !payment.closest('.ev-pdp-express')) {
          const paymentShell = payment.closest('.payment-button');
          if (paymentShell) paymentShell.classList.remove('button-solid', 'button-animation');
          makeDetails(t('express','Express checkout'), [payment], 'ev-pdp-express');
        }
      };
      wrapPayment();
      new MutationObserver(wrapPayment).observe(buy, {childList:true, subtree:true});
      const cartButton = buy.querySelector('.add_to_cart_button');
      const sticky = document.querySelector('.sticky_add_to_cart');
      if (cartButton && sticky) {
        new IntersectionObserver(entries => {
          sticky.classList.toggle('ev-pdp-sticky-suppressed', entries[0].boundingClientRect.bottom > 0);
        }, {threshold:[0,1]}).observe(cartButton);
      }
    }
    const about = makeDetails('The Evolvé commitment', [...info.querySelectorAll('.x-block-text,.x-block-text-icon')]);
    const syncProductDetails = () => {
      const details = info.querySelector('[data-product-details]');
      if (!details) return;
      try {
        const variantData = info.querySelector('.variant-selects-main [data-selected-variant]');
        if (!variantData) return;
        const variant = JSON.parse(variantData.textContent);
        const sku = variant?.sku || '';
        const row = details.querySelector('[data-product-sku-row]');
        const value = row.querySelector('[data-product-sku]');
        if (value.textContent !== sku) value.textContent = sku;
        row.hidden = !sku;
        details.querySelectorAll('[data-product-option-row]').forEach(optionRow => {
          const optionValue = variant?.options?.[Number(optionRow.dataset.productOptionIndex)] || '';
          const optionText = optionRow.querySelector('[data-product-option]');
          if (optionText.textContent !== optionValue) optionText.textContent = optionValue;
          optionRow.hidden = !optionValue || optionValue === 'Default Title';
        });
      } catch { /* Native variant selection stays available while its data refreshes. */ }
    };
    syncProductDetails();
    new MutationObserver(syncProductDetails).observe(info, {childList:true, subtree:true, characterData:true});
    const offers = makeDetails(t('offers','Available offers'), [info.querySelector('.x-coupon-code-block')]);
    const security = makeDetails(t('security','Payment & security'), [info.querySelector('.x-block-payment-methods')]);
    const auth = info.querySelector('.x-block-collapsible-tab-evolve_authenticity');
    if (auth) {
      let anchor = auth;
      [about,offers,security].filter(Boolean).forEach(details => { anchor.after(details); anchor = details; });
    }
  };
  const prepareRelatedPhoto = async card => {
    const primary = card.querySelector('.image-first-hover');
    const link = primary?.closest('.x-labels-data');
    if (!link || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    const layer = document.createElement('span');
    layer.className = 'ev-pdp-card-media';
    layer.setAttribute('aria-hidden','true');
    const base = document.createElement('img');
    base.src = imageUrl(primary.getAttribute('src'),750);
    base.alt = '';
    layer.append(base);
    link.append(layer);
    try { await base.decode(); } catch { layer.remove(); return; }
    link.classList.add('ev-pdp-card-photo-ready');
    const handle = new URL(link.href).pathname.match(/\/products\/([^/]+)/)?.[1];
    if (!handle) return;
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) return;
      const product = await response.json();
      if (!presentation.hasNeutralOptions(product.options)) return;
      const model = product.media?.find(m => m.media_type === 'image' && isModel(m.alt));
      if (!model) return;
      const alternate = document.createElement('img');
      alternate.src = imageUrl(model.src,750);
      alternate.alt = '';
      alternate.dataset.photoDescription = model.alt;
      alternate.className = 'ev-pdp-card-alternate';
      layer.append(alternate);
      try { await alternate.decode(); } catch { alternate.remove(); return; }
      requestAnimationFrame(() => requestAnimationFrame(() => link.classList.add('ev-pdp-card-model-ready')));
    } catch { /* Keep the product photo visible if no worn photo is available. */ }
  };
  const prepareRecommendations = () => {
    const section = document.querySelector('[id$="__product-recommendations"]');
    if (!section) return;
    section.classList.add('ev-pdp-recommendations');
    const prepare = () => {
      const carouselList = section.querySelector('[id^="x-product-recommendation-"][id$="-list"]');
      const carousel = carouselList?.closest('.x-splide');
      if (carousel) {
        let grid = section.querySelector('.ev-pdp-related-grid');
        if (!grid) {
          grid = document.createElement('div');
          grid.className = 'ev-pdp-related-grid';
          carousel.before(grid);
        }
        [...carouselList.children].forEach(slide => {
          const card = slide.querySelector(':scope > .card-product');
          if (card) grid.append(card);
        });
        if (grid.children.length) carousel.classList.add('ev-pdp-empty-carousel');
      }
      section.querySelectorAll('.card-product').forEach(card => {
        const title = card.querySelector('.card-info .x-card-title');
        const price = card.querySelector('.card-info .x-card-price');
        if (!title || !price || card.dataset.evPdpPrepared) return;
        card.dataset.evPdpPrepared = 'true';
        prepareRelatedPhoto(card);
        const rating = card.querySelector('.x-review-product');
        if (rating && /^\(\s*0\s*\)$/.test(rating.textContent.trim())) rating.hidden = true;
        const link = document.createElement('a');
        link.className = 'ev-pdp-card-details';
        link.href = title.href;
        link.setAttribute('aria-label', `View details for ${title.title || title.textContent.trim()}`);
        link.textContent = t('details','View details');
        const arrow = document.createElement('span');
        arrow.textContent = ' →';
        arrow.setAttribute('aria-hidden','true');
        link.append(arrow);
        price.after(link);
      });
    };
    prepare();
    new MutationObserver(prepare).observe(section, {childList:true,subtree:true});
  };
  const initialize = () => {
    const page = document.querySelector('.main-product.product-page');
    const media = page?.querySelector('.product-media-container');
    const info = page?.querySelector('[id^="ProductInfo-"]');
    if (!media || !info) return;
    media.parentElement.classList.add('ev-pdp-layout');
    prepareGallery(media);
    prepareInfo(info);
    prepareRecommendations();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
})();
